import * as _ from 'lodash'
import { getBoundaries } from '../../helpers/state-selector'
import moverHelper from '../../helpers/mover-helper'
import mapHelper from '../../helpers/map-helper'

export default {
  name: 'pickup',
  created () {
  
  },
  mounted () {
    mapHelper._isGoogleLoaded({infobox:true}).then(val=>{
      this.initMap()
    })
  },
  data () {
    return {
      polygons : {},
      areaCodes: {},
      selectedAreas: []
    }
  },
  methods: {
    initMap () {

      google.maps.Polygon.prototype.my_getBounds=function(){
        let bounds = new google.maps.LatLngBounds()
        this.getPath().forEach(function(element,index){bounds.extend(element)})
        return bounds
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/Pickup/pickup.script.js